import React , { useState , useEffect , useContext } from "react";
import { Link , NavLink , useNavigate  } from "react-router-dom";
import Orderstatus from '../components/admin/dropdown/Orderstatus';
import  { WebAssetsContext }  from "../App";
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import Swal from 'sweetalert2';
const  Commodityorders = (props) => {

  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const [orders, setOrders] = useState([]);
    const fetchData = () => {
      fetch(api+"getorders")
        .then(res => res.json())
        .then((result) => {
            if(result.status == true)
            {
              setOrders(result.response);
            }
          }
        )
      }
      
  const navigate = useNavigate();
  const HandleClickOnView = (id='') => 
    {
      navigate("/admin/commodity-orders/view/"+id);
    }   
const HandleClickOnDelete = async (id='') => 
  {
    Swal.fire({  
      title: 'Are you sure you want to delete it ?',  
      text: "Once deleted, you will not be able to get it again!",
      icon: 'warning',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        try {
        const resJson =   Delete(id);
        resJson.then(function(output) {
              if(output.status == true)
              {
                Swal.fire({  
                  title: 'Deleted!',  
                  text: "Order has been deleted successfully.",
                  icon: 'success'
                }).then((finalresult) => {
                    if (finalresult.isConfirmed) {
                      fetchData();
                    }
                });
              }
          });
       
          } catch (err) {
          console.log(err);
        }
        
      } 
    });
    
    
  }
  const Delete = async (id='') => 
  {
    const res =  await fetch(api+"deleteOrder", {
            method: "POST",
            body: JSON.stringify({id: id}),
          });
          let resJson = await res.json();
          return resJson;
    }
    
    useEffect(() => {
        fetchData();
    },[])
   

  return (
    <>
       <div className="section-body">
                  <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="pt-4 pl-4 pr-4">
                                <div className="card-header pl-0 pr-0 w-50 float-left">
                                    <h4 className="headercolor">Commodity Orders</h4>
                                </div>
                            </div>
                            <div className="card-body pl-4 pr-4 pb-4 pt-0">
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th className="text-center">S.NO</th>
                                                <th><div className="w-170">Order Id</div></th>
                                                <th><div className="w-170">Product</div></th>
                                                <th>Customer</th>
                                                <th><div className="w-170">TXN Amount</div></th>
                                                <th><div className="w-170">TXN Date</div></th>
                                                <th>Order Type</th>
                                                <th>Deliverable Status</th>
                                                <th>Order Status</th>
                                                <th className="text-right"  width={"120px"}><div className="w-170">Action</div></th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                          {orders.length > 0 ? orders.map((order , i)  => (
                                            <tr key={i}>
                                                <td className="text-center">{i + 1}</td>
                                                
                                                <td>{order.id}</td>
                                                <td>
                                                  {order.product_name}
                                                  
                                                </td>
                                                <td>
                                                <span  id={'info_'+order.id} 
                                                    data-tooltip-content={order.customer_email +' | '+ order.customer_phone}
                                                  >{order.customer_name}
                                                    </span>
                                                    <Tooltip anchorId={'info_'+order.id}  />
                                                 </td>
                                                <td>{props.currencySymbol()}{order.total_amount}</td>
                                                <td>{props.changeDateFotmate(order.order_date , 'DD-MM-YYYY h:m:s a')}</td>
                                                <td>
                                                  
                                                { order.order_type == 'Sell' ? <div className="badge badge-sm badge-danger">Sell</div> : ''}
                                                { order.order_type == 'Purchase' ? <div className="badge badge-sm badge-success">Buy</div> : ''}
                                                </td>

                                                <td>
                                                  
                                                  { order.deliverable_status == 'Delivery' ? <div className="badge badge-sm badge-dark">Delivery</div> : ''}
                                                  { order.deliverable_status == 'Virtual' ? <div className="badge badge-sm badge-light">Virtual</div> : ''}
                                                  </td>

                                                <td>
                                                    <Orderstatus key={i} status={order.order_status} orderid={order.id}  /> 
                                                </td>
                                               

                                                <td className="text-right">
                                                  
                                                  <button role="button"  id={'view_'+order.id} onClick={() => HandleClickOnView(order.id)}  className="btn btn-icon btn-primary mr-2" data-tooltip-content="View Details" ><i className="far fa-eye"></i></button>
                                                  <Tooltip anchorId={'view_'+order.id}  />


                                                  <button role="button"  id={'delete_'+order.id}  onClick={() => HandleClickOnDelete(order.id)} className="btn btn-icon btn-danger" data-tooltip-content="Delete" ><i className="far fa-trash-alt"></i></button>
                                                  <Tooltip anchorId={'delete_'+order.id}  />

                                                  
                                                </td>
                                            </tr>
                                            ))  : 

                                            <tr><td colSpan="10" className="text-center">Data not yet found. </td></tr> 
                                           }
                                            
                                          </tbody>
                                    </table>
                                  </div>
                            </div>
                        </div>
                      </div>
                  </div>
                  </div>
    </>

  );
}

export default Commodityorders;
